/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck
/* eslint-disable @typescript-eslint/no-explicit-any */
declare let md5: any;
declare let ServerDefine: any;
declare let DataKeyDefine: any;
declare let SystemTipsCbTag: any;
declare let SystemTipsBtnStyle: any;
type HallTabViews = any;
declare let PopupViews: any;
import {
  GameType,
  GameTypeKeys,
  GameTypeNames,
  Providers,
  ProvidersKeys,
  ProvidersNames,
} from '@/defines/EnumDefine'
import { ModuleBase } from './ModuleBase'
import { hall } from '@/hall'
import { WebDefine } from '@/defines/WebDefine'
import { log } from '@/utils/functions'
import { base } from '@/base/base'
import { WebServerType } from '@/net/HttpUtil'
import { webErrorMsg } from '@/defines/WebError'

export type ProviderTypeInfo = {
  name?: string
  icon?: string
  provider: Providers
}

const PRE_PAGE_COUNT = 12

//横屏游戏
const arrGameH = [
  7109, 7111, 7112, 7114, 7115, 7117, 7124, 7139, 17003, 17005, 17007, 17009, 17011, 17013, 17015,
  17017, 17018, 17019, 17020, 17021, 17022, 17023, 17024, 17025, 17026, 17030, 17031, 17032, 17033,
  17034, 17035, 17036, 17037, 17038, 17039, 17040, 17041, 17042, 17043, 17046, 17047, 17048, 17049,
  17050, 17051, 17053, 17057, 17058, 17059, 17060, 17061, 17062, 17063, 17065, 17066, 17067, 17068,
  17069, 17070, 23003, 23023, 23024, 23032, 23033, 23034, 23035, 23036, 23037, 23038, 23039,
]

const SHOW_GAME_TYPES = [
  GameType.HotGame,
  GameType.Slots,
  GameType.Arcade,
  GameType.TableCard,
  GameType.Fishing,
  GameType.Casino,
  GameType.Lottery,
]

// 最多保留16个最近玩过的游戏
const PLAYED_AMOUNT_MAX = 16

export class HallModule extends ModuleBase {
  private subgameListData_: any = null
  private subgameInfoCache_: { [key: number]: any } = {}
  private playedGameIds_: number[] = []

  private first_ = true
  private successOrders_: any = {}

  subgameListDataMD5: string = ""

  showGameTypes: GameType[] = SHOW_GAME_TYPES

  GAME_TYPE_INFOS = {}

  PROVIDER_TYPE_INFOS = {}

  gameListInType = null

  isHallIn = true //现在是否是在大厅打开的图标显示
  merchant = '' //游戏供应商，用来退出游戏使用

  hotGame: any[] = [] //带有标签的前20个热门游戏

  public init(): void {
    this.GAME_TYPE_INFOS = {
      [GameType.PLAYED]: {
        gameType: GameType.PLAYED,
        name: hall.Language.Game_type_name_palyer,
        icon: 'type_icon_played',
        title: 'title_played',
      },
      [GameType.All]: {
        gameType: GameType.All,
        name: hall.Language.Game_provider_All,
        icon: 'type_icon_played',
        title: 'title_played',
      },
      [GameType.HotGame]: {
        gameType: GameType.HotGame,
        name: hall.Language.Game_type_name_hot,
        icon: 'type_icon_hot',
        title: 'title_hot',
      },
      [GameType.Slots]: {
        gameType: GameType.Slots,
        name: hall.Language.Game_type_name_slots,
        icon: 'type_icon_slot',
        title: 'title_slots',
      },
      [GameType.TableCard]: {
        gameType: GameType.TableCard,
        name: hall.Language.Game_type_name_tableCard,
        icon: 'type_icon_table',
        title: 'title_table',
      },
      [GameType.Casino]: {
        gameType: GameType.Casino,
        name: hall.Language.Game_type_name_casino,
        icon: 'type_icon_live',
        title: 'title_live',
      },
      [GameType.Arcade]: {
        gameType: GameType.Arcade,
        name: hall.Language.Game_type_name_arcade,
        icon: 'type_icon_crash',
        title: 'title_crash',
      },
      [GameType.Fishing]: {
        gameType: GameType.Fishing,
        name: hall.Language.Game_type_name_fishing,
        icon: 'type_icon_fishing',
        title: 'title_fishing',
      },
      [GameType.Lottery]: {
        gameType: GameType.Lottery,
        name: hall.Language.Game_type_name_lottery,
        icon: 'type_icon_live',
        title: 'title_live',
      },
    }

    this.PROVIDER_TYPE_INFOS = {
      [Providers.All]: {
        name: hall.Language.Game_provider_All,
        icon: 'big_provider_pgsoft',
        provider: Providers.All,
      },
      [Providers.PG]: {
        name: hall.Language.Game_provider_PG,
        icon: 'big_provider_pgsoft',
        provider: Providers.PG,
      },
      [Providers.FaChai]: {
        name: hall.Language.Game_provider_FaChai,
        icon: 'big_provider_fachai',
        provider: Providers.FaChai,
      },
      [Providers.PP]: {
        name: hall.Language.Game_provider_PP,
        icon: 'big_provider_pp',
        provider: Providers.PP,
      },
      [Providers.Bng]: {
        name: hall.Language.Game_provider_BNG,
        icon: 'big_provider_bng',
        provider: Providers.Bng,
      },
      [Providers.JILI]: {
        name: hall.Language.Game_provider_JILI,
        icon: 'big_provider_jili',
        provider: Providers.JILI,
      },
      [Providers.Hacksaw]: {
        name: hall.Language.Game_provider_Hacksaw,
        icon: 'big_provider_hacksaw',
        provider: Providers.Hacksaw,
      },
      [Providers.SP]: {
        name: hall.Language.Game_provider_SP,
        icon: 'big_provider_spribe',
        provider: Providers.SP,
      },
      [Providers.Bgaming]: {
        name: hall.Language.Game_provider_Bgaming,
        icon: 'big_provider_bgaming',
        provider: Providers.Bgaming,
      },
      [Providers.TADA]: {
        name: hall.Language.Game_provider_TADA,
        icon: 'big_provider_tada',
        provider: Providers.TADA,
      },
      [Providers.NextSPIN]: {
        name: hall.Language.Game_provider_NextSPIN,
        icon: 'big_provider_nextspin',
        provider: Providers.NextSPIN,
      },
      [Providers.EV]: {
        name: hall.Language.Game_provider_EV,
        icon: 'big_provider_evolive',
        provider: Providers.EV,
      },
      [Providers.WONWON]: {
        name: hall.Language.Game_provider_WONWON,
        icon: 'big_provider_wonwon',
        provider: Providers.WONWON,
      },
      [Providers.CQ9]: {
        name: hall.Language.Game_provider_CQ9,
        icon: 'big_provider_cq9',
        provider: Providers.CQ9,
      },
      [Providers.AOG]: {
        name: hall.Language.Game_provider_AOG,
        icon: 'big_provider_aog',
        provider: Providers.AOG,
      },
      [Providers.RED]: {
        name: hall.Language.Game_provider_RED,
        icon: 'big_provider_red',
        provider: Providers.RED,
      },
      [Providers.V8]: {
        name: hall.Language.Game_provider_V8,
        icon: 'big_provider_v8',
        provider: Providers.V8,
      },
      [Providers.JDB]: {
        name: hall.Language.Game_provider_JDB,
        icon: 'big_provider_jdb',
        provider: Providers.JDB,
      },
      [Providers.InOut]: {
        name: hall.Language.Game_provider_InOut,
        icon: 'big_provider_InOut',
        provider: Providers.InOut,
      },
      [Providers.KoolBet]: {
        name: hall.Language.Game_provider_KoolBet,
        icon: 'big_provider_KoolBet',
        provider: Providers.KoolBet,
      },
      [Providers.Mini]: {
        name: hall.Language.Game_provider_Mini,
        icon: 'big_provider_Mini',
        provider: Providers.Mini,
      },
    }

    this.reinit()
  }

  public onClear(): void {
    this.hotGame = []
    this.reinit()
  }

  public onLoad(): void {
    if (base.channelId == 2) {
      ;(this.GAME_TYPE_INFOS as any)[GameType.Casino].name = 'Casino Games'
      ;(this.GAME_TYPE_INFOS as any)[GameType.Casino].title = 'title_casinogames'
    }

    this.onPreloadData()
    this.loadSubgameListData_()
    this._loadPlayedGameIds()
  }

  public onDestroy(): void {}

  public onPreloadData(): void {
    this.postHomeGameList()
    this.postGameSupplierGames()
  }

  public inits2c(): void {}

  public showHall(): void {
    const HallBG = base.uiHudSystem.getFromActiveHud('HallBG', true)
    if (HallBG == null) {
      base.uiHudSystem.show('HallBG')
      base.uiHudSystem.show('HallTop')
    }

    //hall.hallModule.postdownScore();
    hall.userModule.sendClient2ProxyReqGetBalance() //刷新玩家金币
    // base.sdkWrapper.sendSEProperties()
    // base.sdkWrapper.disposeAttributionData()
  }

  public hideHall(): void {
    base.uiHudSystem.hide('HallBG')
    base.uiHudSystem.hide('HallTop')
    base.uiHudSystem.hide('HallPanel')
    base.uiHudSystem.hide('AccountPanel')
  }

  public postdownScore(): void {
    const data = {
      uid: hall.userModule.userId,
      cid: base.channelId,
    }

    base.uiHudSystem.show('SystemWaitingCopy')
    base.httpUtil
      .postJson(WebDefine.downScore, data, WebServerType.PHP, {
        retryCount: 3,
        retryDelay: 2000,
      })
      .then((response) => {
        log('postdownScore Success:', response)
        base.uiHudSystem.hide('SystemWaitingCopy')
        if (response.code !== 200) {
          const msg = `${hall.Language.NetworkError}(${response.code})`
          const params = {
            callback: (tag: any) => {
              log('SystemTips callback tag =', tag)
              hall.loginModule.reLogin()
            },
          }
          base.uiHudSystem.show('SystemTips', msg, params)
        } else {
          hall.userModule.sendClient2ProxyReqGetBalance() //刷新玩家金币
        }
      })
      .catch((_error: any) => {
        log('postdownScore Final failure:', _error)
        base.uiHudSystem.hide('SystemWaitingCopy')
        const msg = `${hall.Language.NetworkError}`
        const params = {
          mark: true,
          callback: (tag: any) => {
            log('SystemTips callback tag =', tag)
            hall.loginModule.reLogin()
          },
        }
        base.uiHudSystem.show('SystemTips', msg, params)
      })
  }

  public postdownScoreWithNoTip(): void {
    const data = {
      uid: hall.userModule.userId,
      cid: base.channelId,
    }

    base.httpUtil
      .postJson(WebDefine.downScore, data, WebServerType.PHP, {
        retryCount: 3,
        retryDelay: 2000,
      })
      .then((response) => {
        log('postdownScore Success:', response)
      })
      .catch((_error: any) => {
        log('postdownScore Final failure:', _error)
      })
  }

  //大厅的列表数据，大厅的子游戏数量数据，每个下拉刷新页数，以及每个大厅列表左右按钮翻页
  //搜索问题，
  //要不要提前拿一页的数据，要的。还是说直接要什么搜索返回了在展示什么。GameListPanel。而且要考虑刷新，一连串发很多类型的，
  // 刷新的不是自己的怎么办
  //数量只有子游戏和厂商，如果子游戏 里面厂商那怎么办

  //大厅初始列表 --种类
  public postHomeGameList(): void {
    const data = {
      //uid: hall.userModule.userId,
      cid: base.channelId,
      //version: "1.0.0",
      page_size: PRE_PAGE_COUNT,
    }

    base.httpUtil
      .postJson(WebDefine.GameTypeGames, data, WebServerType.PHP, {
        retryCount: 3,
        retryDelay: 2000,
      })
      .then((response) => {
        if (response.code !== 200) {
          base.toast(webErrorMsg(response.code, response.msg))
          return
        }
        this.refreshSubgameListInit_(response.data)
      })
      .catch(() => {})
  }

  //大厅初始列表 --游戏厂商
  public postGameSupplierGames(): void {
    const data = {
      //uid: hall.userModule.userId,
      cid: base.channelId,
      //version: "1.0.0",
      page_size: PRE_PAGE_COUNT,
    }

    base.httpUtil
      .postJson(WebDefine.GameSupplierGames, data, WebServerType.PHP, {
        retryCount: 3,
        retryDelay: 2000,
      })
      .then((response) => {
        if (response.code !== 200) {
          base.toast(webErrorMsg(response.code, response.msg))
          return
        }
        this.refreshSubgameListInit_(response.data)
      })
      .catch(() => {})
  }

  //游戏厂商列表下发
  public postGameSupplierList(page: number, supplier: string, onSuccess?: () => void): void {
    const data = {
      //uid: hall.userModule.userId,
      cid: base.channelId,
      //version: "1.0.0",
      page_num: page,
      page_size: PRE_PAGE_COUNT,
      supplier_name: supplier,
    }

    base.httpUtil
      .postJson(WebDefine.getGameSupplierList, data, WebServerType.PHP, {
        retryCount: 3,
        retryDelay: 2000,
      })
      .then((response) => {
        if (response.code !== 200) {
          base.toast(webErrorMsg(response.code, response.msg))
          return
        }

        this.refreshSubgameList_(response.data, true)
        if (onSuccess) {
          onSuccess()
        }
      })
      .catch(() => {})
  }

  //游戏类型列表下发
  public postGameTypeList(page: number, type: string, onSuccess?: () => void): void {
    const data = {
      //uid: hall.userModule.userId,
      cid: base.channelId,
      //version: "1.0.0",
      page_num: page,
      page_size: PRE_PAGE_COUNT,
      type_name: type,
    }

    base.httpUtil
      .postJson(WebDefine.getGameTypeList, data, WebServerType.PHP, {
        retryCount: 3,
        retryDelay: 2000,
      })
      .then((response) => {
        if (response.code !== 200) {
          base.toast(webErrorMsg(response.code, response.msg))
          return
        }

        this.refreshSubgameList_(response.data, true)
        if (onSuccess) {
          onSuccess()
        }
      })
      .catch(() => {})
  }

  //游戏列表下发（搜索为主）
  public postGameList(page: number, name: string = '', onSuccess?: () => void): void {
    const data = {
      //uid: hall.userModule.userId,
      cid: base.channelId,
      //version: "1.0.0",
      page_num: page,
      page_size: PRE_PAGE_COUNT,
      name: name,
    }

    base.httpUtil
      .postJson(WebDefine.getlistbyCid, data, WebServerType.PHP, {
        retryCount: 3,
        retryDelay: 2000,
      })
      .then((response) => {
        if (response.code !== 200) {
          base.toast(webErrorMsg(response.code, response.msg))
          return
        }

        this.refreshSubgameList_(response.data, true, name)
        if (onSuccess) {
          onSuccess()
        }
      })
      .catch(() => {})
  }

  public cleanSrarch() {
    if (this.subgameListData_) {
      this.subgameListData_['search'] = []
      this.subgameListData_['searchNum'] = 0
    }
  }

  //初始化加载大厅的图标
  private refreshSubgameListInit_(data: any) {
    if (!data) {
      return
    }
    if (!this.subgameListData_) {
      this.subgameListData_ = {
        allListInfo: [], //所有游戏的内容
        allList: [], //所有的子游戏
        list: [], // 确保 list 初始化为空数组(搜索所有游戏的)
        providerNum: {} as any, //每个厂商游戏的数量
        typesNum: {} as any, //每个类型游戏的数量
        provider: {} as any, //每个类型子游戏
        types: {} as any, //游戏类型子游戏
        search: [],
        //搜索出来的数据
      }
    }

    for (let gamelist = 0; gamelist < data.length; gamelist++) {
      const initInfo = data[gamelist]

      for (let i = 0; i < initInfo.games.length; i++) {
        //把新的数据做成跟之前一样的列表数据
        const info = initInfo.games[i]
        //添加typeAllList
        let isallList = true
        for (let j = 0; j < this.subgameListData_.allList.length; j++) {
          if (this.subgameListData_.allList[j] == info.gid) {
            isallList = false
          }
        }
        if (isallList) {
          this.subgameListData_.allList.push(info.gid)
        }

        //添加allListInfo
        let isallListInfo = true
        for (let inf = 0; inf < this.subgameListData_.allListInfo.length; inf++) {
          if (this.subgameListData_.allListInfo[inf] == info.gid) {
            isallListInfo = false
          }
        }
        if (isallListInfo) {
          this.subgameListData_.allListInfo.push(info)
        }

        //添加providers

        for (let key = 0; key < ProvidersNames.length; key++) {
          // 过滤掉反向映射的数字键
          const provider = ProvidersNames[key]
          if (initInfo.supplier_name === provider && provider != '') {
            const providerKey = ProvidersKeys[key] as any
            this.subgameListData_.providerNum[providerKey] = initInfo.total_count //游戏厂商子游戏数量
            let supplierList = true
            if (this.subgameListData_.provider[providerKey]) {
              for (let r = 0; r < this.subgameListData_.provider[providerKey].length; r++) {
                if (this.subgameListData_.provider[providerKey][r] == info.gid) {
                  supplierList = false
                }
              }
            } else {
              this.subgameListData_.provider[providerKey] = []
            }
            if (supplierList) {
              this.subgameListData_.provider[providerKey].push(info.gid)
            }
          }
        }

        //添加type
        for (let key2 = 0; key2 < GameTypeNames.length; key2++) {
          // 过滤掉反向映射的数字键

          const gameType = GameTypeNames[key2]
          if (initInfo.type_name === gameType && gameType != '') {
            const GameTypeKey = GameTypeKeys[key2] as any
            let GameTypeList = true
            this.subgameListData_.typesNum[GameTypeKey] = initInfo.total_count //游戏类型子游戏数量
            if (this.subgameListData_.types[GameTypeKey]) {
              for (let t = 0; t < this.subgameListData_.types[GameTypeKey].length; t++) {
                if (this.subgameListData_.types[GameTypeKey][t] == info.gid) {
                  GameTypeList = false
                }
              }
            } else {
              this.subgameListData_.types[GameTypeKey] = []
            }
            if (GameTypeList) {
              this.subgameListData_.types[GameTypeKey].push(info.gid)
            }
          }
        }
      }
    }
    hall.marqueeModule.getJackSubgameIDList()
    hall.eventDispatcher.emit(hall.EventDefine.RefreshSubgameList) //刷新游戏图标列表
    hall.eventDispatcher.emit(hall.EventDefine.ChangeProviderList) //刷新底部游戏厂商
  }

  private refreshSubgameList_(data: any, fromRemote: boolean, name?: string): void {
    if (!data) {
      return
    }

    for (let i = 0; i < data.data.length; i++) {
      //把新的数据做成跟之前一样的列表数据
      const info = data.data[i]

      if (info.supplier_name == '' && info.type_name == '') {
        //这个是全部游戏的
        if (name != '') {
          //搜索来的数据

          let isSearch = true
          for (let sra = 0; sra < this.subgameListData_['search'].length; sra++) {
            if (this.subgameListData_['search'][sra] == info.gid) {
              isSearch = false
            }
          }
          if (isSearch) {
            this.subgameListData_['search'].push(info.gid)
          }

          this.subgameListData_['searchNum'] = data.total_num
        } else {
          this.subgameListData_['allNum'] = data.total_num
          //添加list
          let isList = true
          for (let k = 0; k < this.subgameListData_.list.length; k++) {
            if (this.subgameListData_.list[k].gid == info.gid) {
              isList = false
            }
          }
          if (isList) {
            this.subgameListData_.list.push(info.gid)
          }
        }
      }

      //添加typeAllList
      let isallList = true
      for (let j = 0; j < this.subgameListData_.allList.length; j++) {
        if (this.subgameListData_.allList[j] == info.gid) {
          isallList = false
        }
      }
      if (isallList) {
        this.subgameListData_.allList.push(info.gid)
      }

      //添加allListInfo
      let isallListInfo = true
      for (let inf = 0; inf < this.subgameListData_.allListInfo.length; inf++) {
        if (this.subgameListData_.allListInfo[inf] == info.gid) {
          isallListInfo = false
        }
      }
      if (isallListInfo) {
        this.subgameListData_.allListInfo.push(info)
      }

      //添加providers

      for (let key = 0; key < ProvidersNames.length; key++) {
        // 过滤掉反向映射的数字键
        const provider = ProvidersNames[key]
        if (info.supplier_name === provider && provider != '') {
          const providerKey = ProvidersKeys[key] as string
          if (providerKey) {
            this.subgameListData_.providerNum[providerKey] = data.total_num //游戏厂商子游戏数量
            let supplierList = true
            if (this.subgameListData_.provider[providerKey]) {
              for (let r = 0; r < this.subgameListData_.provider[providerKey].length; r++) {
                if (this.subgameListData_.provider[providerKey][r] == info.gid) {
                  supplierList = false
                }
              }
            } else {
              this.subgameListData_.provider[providerKey] = []
            }
            if (supplierList) {
              this.subgameListData_.provider[providerKey].push(info.gid)
            }
          }
        }
      }

      //添加type
      for (let key2 = 0; key2 < GameTypeNames.length; key2++) {
        // 过滤掉反向映射的数字键

        const gameType = GameTypeNames[key2]
        if (info.type_name === gameType && gameType != '') {
          const GameTypeKey = GameTypeKeys[key2] as any
          this.subgameListData_.typesNum[GameTypeKey] = data.total_num //游戏类型子游戏数量
          let GameTypeList = true
          if (this.subgameListData_.types[GameTypeKey]) {
            for (let t = 0; t < this.subgameListData_.types[GameTypeKey].length; t++) {
              if (this.subgameListData_.types[GameTypeKey][t] == info.gid) {
                GameTypeList = false
              }
            }
          } else {
            this.subgameListData_.types[GameTypeKey] = []
          }
          if (GameTypeList) {
            this.subgameListData_.types[GameTypeKey].push(info.gid)
          }
        }
      }
    }
    //this.subgameListData_ = data;

    // if (fromRemote) {
    //     let changed = this.saveSubgameListData_(this.subgameListData_);
    //     if (!changed) {
    //         return;
    //     }
    // }

    if (this.subgameListData_.list.length === 0) {
      log('Warning: Subgame list length is 0')
    }

    // Validate subgame configurations and remove invalid ones
    // this.checkSubgameInfos_(this.subgameListData_.list);

    // this._disposeSubgameInfo();

    // const allList: number[] = [];
    // for (const game of this.subgameListData_.list) {
    //     allList.push(game.game_id);
    // }
    // if (!this.subgameListData_.types) {
    //     this.subgameListData_.types = {};
    // }
    // this.subgameListData_.types.allList = allList;

    hall.eventDispatcher.emit(hall.EventDefine.RefreshSubgameList) //刷新游戏图标列表
    hall.eventDispatcher.emit(hall.EventDefine.ChangeProviderList) //刷新底部游戏列表数量
  }

  // 处理游戏信息
  _disposeSubgameInfo(): void {
    for (const info of this.subgameListData_.list) {
      this.subgameInfoCache_[info.game_id] = info
    }

    for (const key in Providers) {
      // 过滤掉反向映射的数字键
      if (isNaN(Number(key))) {
        const provider = Providers[key]
        const providerKey = ProvidersKeys[provider]
        const gameIds = this.subgameListData_.providers?.[providerKey] || []

        for (let index = 0; index < gameIds.length; index++) {
          const gameId = gameIds[index]
          const info = this.subgameInfoCache_[gameId]
          if (info) {
            const name = ProvidersNames[provider]
            info['_ProviderName_'] = name
          }
        }
      }
    }

    for (const key in GameType) {
      // 过滤掉反向映射的数字键
      if (isNaN(Number(key))) {
        const gameType = GameType[key]
        const gameIds = this.subgameListData_.types?.[GameTypeKeys[gameType]] || []

        for (let index = 0; index < gameIds.length; index++) {
          const gameId = gameIds[index]
          const info = this.subgameInfoCache_[gameId]
          if (info) {
            const name = GameTypeNames[gameType]
            info['_GameTypeName_'] = name
          }
        }
      }
    }
  }

  private checkSubgameInfos_(subgameList: any[]): void {
    const errorIds: number[] = []

    for (let i = subgameList.length - 1; i >= 0; i--) {
      const info = subgameList[i]
      if (info.platform === undefined || info.platform === 0) {
        if (!info.builtin) {
          if (!info.version_manifest || info.version_manifest.trim() === '') {
            errorIds.push(info.gameid)
            subgameList.splice(i, 1)
          }
        }
      }
    }

    if (errorIds.length > 0) {
      log(`Game info is error: ${errorIds.join(',')}`)
    }
  }

  //获取子游戏数量
  public getSubgameNum(gameType: GameType, provider: Providers, searchStr?: any) {
    if (this.subgameListData_ == null) {
      return 0
    }
    if (gameType == GameType.PLAYED && provider == 0) {
      return this.playedGameIds_.length
    }
    if (searchStr != undefined && searchStr != '' && searchStr != null) {
      return this.subgameListData_['searchNum']
    }

    if (gameType == 1 && provider == 0) {
      //这个是all
      return this.subgameListData_['allNum']
    }
    //gameType =1 也是all，就找厂商
    // if (gameType  && provider) {
    //     //筛选俩个同时候拥有的游戏，才行。现在只有知道数量
    // }
    else {
      if (gameType != 1 && gameType != 0) {
        const gameTypeKey = GameTypeKeys[gameType]
        if (this.subgameListData_.typesNum[gameTypeKey]) {
          return this.subgameListData_.typesNum[gameTypeKey]
        }
      } else if (provider) {
        const providerKey = ProvidersKeys[provider]
        if (this.subgameListData_.providerNum[providerKey]) {
          return this.subgameListData_.providerNum[providerKey]
        }
      }
    }

    return 0
  }

  public getSubgameIDList(
    gameType: GameType,
    provider: Providers,
    searchStr: string = '',
  ): number[] {
    log(`getSubgameIDList gameType = ${gameType}, provider = ${provider}, searchStr = ${searchStr}`)
    if (!this.subgameListData_) {
      return []
    }
    if (searchStr != undefined && searchStr != '' && searchStr != null) {
      return this.subgameListData_['search']
    }

    if (gameType == GameType.All && provider == Providers.All) {
      return this.subgameListData_['list']
    }
    let gameIdsTemp: number[] = []
    const key = GameTypeKeys[gameType]
    log(`getSubgameIDList key = ${key}`)
    let gameIds = null
    if (gameType == GameType.PLAYED) {
      gameIds = this.playedGameIds_
    } //else if (gameType == GameType.Lottery) {
    //gameIds = [1027, 1028]
    //}
    else {
      if (key == 'allList') {
        gameIds = this.subgameListData_[key]
      } else {
        gameIds = this.subgameListData_.types[key]
      }
    }

    if (gameIds) {
      log(`getSubgameIDList gameIds amount1 = ${gameIds.length}`)
      gameIdsTemp = [...gameIds]
    }

    if (gameType == GameType.HotGame && this.hotGame.length == 0) {
      const game = this.subgameListData_.types?.['hotList'] || []
      for (let o = 0; o < game.length; o++) {
        if (o < 20) {
          this.hotGame.push(game[o])
        }
      }
    }

    if (provider !== Providers.All) {
      const providerKey = ProvidersKeys[provider]
      const providerGameIds = this.subgameListData_.provider?.[providerKey] || []

      if (providerGameIds.length === 0) {
        gameIdsTemp = []
      } else {
        gameIdsTemp = gameIdsTemp.filter((id) => providerGameIds.includes(id))
      }
    }
    log(`getSubgameIDList gameIds amount2 = ${gameIdsTemp.length}`)

    // searchStr = String(searchStr || '').trim()
    // if (searchStr != "") {
    //     const lowerCaseSearchStr = searchStr.toLowerCase();
    //     log(`getSubgameIDList searchStr = ${searchStr}`)

    //     gameIdsTemp = gameIdsTemp.filter((id) => {
    //         let name = this.getSubgameName(id)
    //         // log(`getSubgameIDList id = ${id}: name = ${name}`)
    //         return String(name || '').toLowerCase().includes(lowerCaseSearchStr)
    //     });
    // }
    // log(`getSubgameIDList gameIds filter amount3 = ${gameIdsTemp.length}`)

    return gameIdsTemp
  }

  // "channel_id": 1,
  // "game_id": 7158,
  // "priority": 0,
  // "closed": false,
  // "icon": "",
  // "closed_icon": "",
  // "main_mod": "",
  // "builtin": true,
  // "version_manifest": "",
  // "use_tcp": true,
  // "screen": true,
  // "platform": 2,
  // "close_btn_pos": "20,20,0,0",
  // "Name": "Fan Tan"
  public getSubgameInfo(gameId: number): any {
    if (this.subgameListData_) {
      for (let i = 0; i < this.subgameListData_.allListInfo.length; i++) {
        if (this.subgameListData_.allListInfo[i].gid == gameId) {
          return this.subgameListData_.allListInfo[i]
        }
      }
    }
    return null
  }

  public getSubgameName(gameId: number): any {
    const info = this.subgameInfoCache_[gameId]
    return info ? info.Name : 'Unknown'
  }

  getGameTypeInfo(gameType: GameType) {
    return (this.GAME_TYPE_INFOS as any)[gameType]
  }

  getProviderInfo(provider: Providers): ProviderTypeInfo {
    return (this.PROVIDER_TYPE_INFOS as any)[provider]
  }

  getProviderInfosByArray(providers: Providers[]): ProviderTypeInfo[] {
    const infos = []
    for (let i = 0; i < providers.length; i++) {
      const provider = providers[i]
      infos.push(this.PROVIDER_TYPE_INFOS[provider])
    }

    return infos
  }

  getProviderGameAmount(gameType: GameType, provider: Providers): number {
    //现在获得数量应该换成直接拿数量
    const gameIds = this.getSubgameNum(gameType, provider)
    return gameIds
  }

  private saveSubgameListData_(data: any): boolean {
    const jsonStr = JSON.stringify(data)
    const strMD5 = md5(jsonStr)
    if (strMD5 == this.subgameListDataMD5) {
      return false
    }

    this.subgameListDataMD5 = strMD5
    localStorage.setItem(hall.DataKeyDefine.SubgameListCache, JSON.stringify(data))
    return true
  }

  private loadSubgameListData_() {
    const jsonStr = localStorage.getItem(hall.DataKeyDefine.SubgameListCache)
    if (jsonStr != null) {
      this.subgameListDataMD5 = md5(jsonStr)
      const data = JSON.parse(jsonStr)
      this.refreshSubgameList_(data, false)
    }
  }

  addPlayedGame(gameId: number) {
    const index = this.playedGameIds_.indexOf(gameId)
    if (index == 0) {
      // gameId 已经在首位
      return
    } else if (index >= 1) {
      this.playedGameIds_.splice(index, 1) // 移除已存在的
    }

    this.playedGameIds_.unshift(gameId) // 插入首位
    this.playedGameIds_.splice(PLAYED_AMOUNT_MAX)

    this._savePlayedGameIds()
    hall.eventDispatcher.emit(hall.EventDefine.PlayedGameIdsChange)
  }

  _savePlayedGameIds() {
    localStorage.setItem(hall.DataKeyDefine.PlayedGameIds, JSON.stringify(this.playedGameIds_))
  }

  _loadPlayedGameIds() {
    const jsonStr = localStorage.getItem(hall.DataKeyDefine.PlayedGameIds)
    if (jsonStr != null) {
      const data = JSON.parse(jsonStr)
      this.playedGameIds_ = data
    }
  }

  postSubgameFree(gameId: number) {
    const data = {
      gid: gameId,
      uid: hall.userModule.userId,
      cid: base.channelId,
    }

    base.httpUtil
      .postJson(WebDefine.getH5FreeGame, data, WebServerType.PHP, {
        retryCount: 3,
        retryDelay: 2000,
      })
      .then((response) => {
        log('postSubgameUrl Success:', response)
        base.uiHudSystem.hide('SystemWaiting')

        if (response.code !== 200) {
          base.toast(webErrorMsg(response.code, response.msg))
          return
        }

        this.postSubgameUrl(gameId)
      })
      .catch((error) => {
        log('postSubgameUrl Final failure:', error)
        base.uiHudSystem.hide('SystemWaiting')
      })

    base.uiHudSystem.show('SystemWaiting')
  }

  postSubgameUrl(gameId: number) {
    const gameInfo = hall.hallModule.getSubgameInfo(gameId)
    if (gameInfo && gameInfo.merchant == 'self') {
      const token = base.app.token
      const uuid = localStorage.getItem(DataKeyDefine.UUID)
      let gameUrl = ServerDefine.SELF_GAME_URL_RELEASE
      if (!base.publish) {
        gameUrl = ServerDefine.SELF_GAME_URL_TEST
      }
      gameUrl = gameUrl + gameId + '/?token=' + token + '&uuid=' + uuid

      this.openSubgameUrl(gameUrl, gameId)
      this.addPlayedGame(gameId)
      hall.hallModule.merchant = 'self'
      return
    }

    //let language = i18nMgr.getLanguage()

    const data = {
      gid: gameId,
      uid: hall.userModule.userId,
      cid: base.channelId,
      //lg:language,
    }

    base.httpUtil
      .postJson(WebDefine.getH5GameUrl, data, WebServerType.PHP, {
        retryCount: 3,
        retryDelay: 2000,
      })
      .then((response) => {
        log('postSubgameUrl Success:', response)
        base.uiHudSystem.hide('SystemWaiting')

        if (response.code !== 200) {
          base.toast(webErrorMsg(response.code, response.msg))
          return
        }

        localStorage.setItem('mCurGameId', gameId.toString()) //当前在玩的游戏ID
        this.openSubgameUrl(response.data.url, gameId)
        this.addPlayedGame(gameId)
      })
      .catch((error) => {
        log('postSubgameUrl Final failure:', error)
        base.uiHudSystem.hide('SystemWaiting')
      })

    base.uiHudSystem.show('SystemWaiting')
  }

  // 检测移动设备并调整打开方式
  openSubgameUrl(url: string, gameId: any) {
    hall.jackpotGamsModule.isCanShow = true
    if (arrGameH.includes(gameId)) {
      ;(globalThis as any).bGameH = true
      base.uiHudSystem.show('SubgamePanel', url)
    } else {
      ;(globalThis as any).bGameH = false
      base.uiHudSystem.show('SubgamePanel', url)
    }

    // if (sys.isBrowser) {
    //     base.uiHudSystem.show("SubgamePanel", url);
    // } else {
    //     base.app.openURL(url)
    // }
  }

  reinit() {
    this.first_ = true
    this.successOrders_ = {}
  }

  isSendAFEvent(order: any) {
    if (this.successOrders_[order]) {
      log('[warning] af event has been sent', order)
      return false
    } else {
      this.successOrders_[order] = 1
      return true
    }
  }

  showHallTabView(tabView: HallTabViews) {
    hall.eventDispatcher.emit(hall.EventDefine.ChangeHallTopTab, tabView)
  }

  setGameListType(type: any) {
    this.gameListInType = type
  }

  getGameListType() {
    return this.gameListInType
  }

  isHotGame(id: any) {
    for (let i = 0; i < this.hotGame.length; i++) {
      if (id == this.hotGame[i]) {
        return true
      }
    }
    return false
  }

  // 是否需要弹窗
  popupView() {
    //如果玩家是游客的话，要弹绑定手机号
    if (hall.loginModule.loginType == 1) {
      //if (window.matchMedia('(display-mode: standalone)').matches) {
      //hall.popupViewModule.addPopupView(PopupViews.RegisterBindPhonePanel);
      //hall.popupViewModule.addPopupView(PopupViews.BindingPhonePanel);
      hall.popupViewModule.addPopupView(PopupViews.BindingBeforePanel)
      // }
    }
  }

  //MARK:在大厅的时候版本检测
  public postGetAPPVersion(): void {
    const data = {
      uid: hall.userModule.userId,
      cid: base.channelId,
      version: '1.0.0',
    }

    base.httpUtil
      .postJson(WebDefine.getVersion, data, WebServerType.PHP, {
        retryCount: 3,
        retryDelay: 2000,
      })
      .then((response) => {
        if (response.code !== 200) {
          base.toast(webErrorMsg(response.code, response.msg))
          return
        }

        const strSvrVersion = response.data.version
        const strLocationVer = localStorage.getItem('strLocationVer')
        if (strLocationVer && strSvrVersion && strLocationVer != strSvrVersion) {
          const msg = `${hall.Language.newAPPVersionTip}`
          const params = {
            callback: (tag: any) => {
              if (tag == SystemTipsCbTag.YES) {
                location.reload()
              }
            },
            btnStyle: SystemTipsBtnStyle.TwoBtns,
          }
          base.uiHudSystem.show('SystemTips', msg, params)
        }
      })
      .catch(() => {})
  }

  getHotGameList() {
    if (this.subgameListData_) {
      return this.subgameListData_.types['hotList']
    }
    return []
  }
}
